import { render, staticRenderFns } from "./industrialSystem.vue?vue&type=template&id=383bb6db&scoped=true&"
import script from "./industrialSystem.vue?vue&type=script&lang=js&"
export * from "./industrialSystem.vue?vue&type=script&lang=js&"
import style0 from "./industrialSystem.vue?vue&type=style&index=0&id=383bb6db&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383bb6db",
  null
  
)

export default component.exports